// extracted by mini-css-extract-plugin
export default {"center":"Affiliates_center__-yni+","background":"Affiliates_background__qhnnh","grid":"Affiliates_grid__At3MH"};